import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';
import { IBank } from '../../../types/promosPage';

export function trackBankListShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.BankPromo,
      },
    },
  });
}

export function trackBankItemClick(bank: IBank) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'Click',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.BankPromo,
        bank_id: bank.id,
      },
    },
  });
}
